import type {
    ConnectorItemParametricState,
    EntityItemParametricState,
    ItemParametricState,
} from '@toolproof-core/visualization/_contract/item';
import type { ItemKey } from '@toolproof-core/visualization/_contract/key';


export type ItemParametricStateEntry = EntityItemParametricState | ConnectorItemParametricState;
export type ItemParametricStateByKey = Partial<Record<ItemKey, ItemParametricStateEntry>>;

type ItemParametricStateContainer = {
    itemParametricStateByKey?: ItemParametricStateByKey;
};

function isConnectorItemKey(itemKey: ItemKey): itemKey is ItemKey<'connector'> {
    return itemKey.startsWith('item:connector:');
}

function isEntityItemKey(itemKey: ItemKey): itemKey is ItemKey<'entity'> {
    return itemKey.startsWith('item:entity:');
}

export function toItemParametricState(state: ItemParametricStateContainer | undefined): ItemParametricState | undefined {
    if (!state) return undefined;

    const combinedByItemKey: ItemParametricStateByKey = {
        ...(state.itemParametricStateByKey ?? {}),
    };

    const entityItemByKey: NonNullable<ItemParametricState['entityItemByKey']> = {};
    const connectorItemByKey: NonNullable<ItemParametricState['connectorItemByKey']> = {};

    for (const [itemKey, entry] of Object.entries(combinedByItemKey)) {
        if (!entry) continue;

        const typedItemKey = itemKey as ItemKey;
        if (isEntityItemKey(typedItemKey)) {
            entityItemByKey[typedItemKey] = entry;
            continue;
        }

        if (isConnectorItemKey(typedItemKey)) {
            connectorItemByKey[typedItemKey] = entry;
        }
    }

    return {
        ...(Object.keys(entityItemByKey).length === 0 ? {} : { entityItemByKey }),
        ...(Object.keys(connectorItemByKey).length === 0 ? {} : { connectorItemByKey }),
    };
}
